import { render, staticRenderFns } from "./attendance-settings.vue?vue&type=template&id=5d01b20f&scoped=true&"
import script from "./attendance-settings.vue?vue&type=script&lang=js&"
export * from "./attendance-settings.vue?vue&type=script&lang=js&"
import style0 from "./attendance-settings.vue?vue&type=style&index=0&id=5d01b20f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d01b20f",
  null
  
)

export default component.exports